import { pageListOrder } from '@/defaultVerbiages';

/**
 * Returns page slugs (same strings as `pageListOrder` / `onAccess` from in-app navigation)
 * from the start of the flow through the target route — used after resume so back/review
 * aligns with "borrower already completed these steps".
 */
function getPageSlugsThroughTargetRoutePath(targetPath: string): string[] {
  const slug = targetPath.replace(/^\//, '').split('?')[0];
  if (!pageListOrder.includes(slug)) {
    return [];
  }
  const idx = pageListOrder.indexOf(slug);
  return pageListOrder.slice(0, idx + 1);
}

export function markResumeProgressOnAccess(onAccess: (page: string) => void, targetPath: string): void {
  for (const slug of getPageSlugsThroughTargetRoutePath(targetPath)) {
    onAccess(slug);
  }
}
